const dt = (s) => new Date(s).toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "short" });

export const AudienceVisitors = ({ rows }) => (
  <div className="bg-white border border-slate-200 rounded-md overflow-x-auto" data-testid="aud-visitors">
    <div className="px-4 pt-4 pb-2">
      <div className="text-[11px] font-bold uppercase tracking-wider text-slate-500">Visiteurs les plus fidèles</div>
      <p className="text-xs text-slate-500 mt-0.5">Visiteurs anonymes reconnus grâce au cookie accepté : nombre de visites (consultations distinctes) sur la période. Ceux qui refusent le cookie ne sont comptés qu'à la journée.</p>
    </div>
    <table className="w-full text-sm">
      <thead className="bg-slate-50 text-[11px] uppercase tracking-wider text-slate-500">
        <tr>{["Visiteur", "Visites", "Pages", "Sites consultés", "1re visite", "Dernière visite", "Provenance", "Appareil", "Pays"].map((h) => <th key={h} className="text-left px-4 py-2 font-bold">{h}</th>)}</tr>
      </thead>
      <tbody>
        {rows.length === 0 && <tr><td colSpan={9} className="px-4 py-6 text-center text-slate-400">Aucun visiteur reconnu pour l'instant</td></tr>}
        {rows.map((r) => (
          <tr key={r.id} className="border-t border-slate-100" data-testid={`aud-visitor-${r.id}`}>
            <td className="px-4 py-2 font-mono text-xs">#{r.id}</td>
            <td className="px-4 py-2"><span className={`inline-block min-w-[28px] text-center px-2 py-0.5 rounded-full text-xs font-bold ${r.visits > 1 ? "bg-amber-100 text-amber-800" : "bg-slate-100 text-slate-600"}`}>{r.visits}</span></td>
            <td className="px-4 py-2">{r.pages}</td>
            <td className="px-4 py-2 text-xs">{r.sites.join(" · ")}</td>
            <td className="px-4 py-2 text-xs whitespace-nowrap">{dt(r.first)}</td>
            <td className="px-4 py-2 text-xs whitespace-nowrap">{dt(r.last)}</td>
            <td className="px-4 py-2 text-xs">{r.source}</td>
            <td className="px-4 py-2 text-xs">{r.device}</td>
            <td className="px-4 py-2 text-xs">{r.country}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);
